var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,1V3.269H8.25V1H3.75V3.269H1.5V1H0V12.347H12V1Zm.75,10.591H.75V4.782h10.5Z",
    transform: "translate(0 -0.347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0h.653V1.959H3Z",
    transform: "translate(-0.731 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0h.653V1.959H12Z",
    transform: "translate(-2.922 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.403,
    height: 2.403,
    transform: "translate(2.469 6.212)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDark);
export default __webpack_public_path__ + "static/media/calendar-dark.7d9e09d4.svg";
export { ForwardRef as ReactComponent };